export default "__VITE_ASSET__db8416cb__"